import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
// components
import BookADemoButton from '../../ui/BookADemoButton'
import TrademarkText from '../../ui/TrademarkText'
// views
import AnimatedContainer from '../../ui/AnimatedContainer/animatedContainer'
import {
  descriptionAnimation,
  titleAnimation,
} from '../../../constants/animation'
// assets
import { Link } from 'react-router-dom'

const HomeHeroComponent = ({
  id,
  className = '',
  title = 'Turn Workforce Data Into Strategic Intelligence',
  description = 'Pod is a patent-pending AI workforce intelligence platform that transforms fragmented workforce data into actionable, explainable intelligence for enterprise and government leaders.',
  poweredBy,
  learnMoreHref = '/#overview',
  learnMoreLabel = 'Learn More',
  credibilityLine = 'Trusted in enterprise, government, and mission-critical workforce environments.',
  backgroundImage,
  children,
}) => {
  const supportingCopy = poweredBy === undefined ? (
    <>
      Powered by the proprietary{' '}
      <TrademarkText>Pod Intelligence Core™</TrademarkText>{' '}
      architecture.
    </>
  ) : poweredBy

  return (
    <section
      id={id}
      className={`overview-section home-hero-content ${className}`.trim()}
      style={
        backgroundImage
          ? { '--home-hero-background': `url("${backgroundImage}")` }
          : undefined
      }
    >
      <div className='box'>
        <AnimatedContainer className='home-hero-content-container'>
          <div>
            <motion.span
              className='overview-title home-hero-overview-title'
              variants={titleAnimation}
            >
              {title}
            </motion.span>
            <motion.p
              className='description home-hero-description'
              variants={descriptionAnimation}
            >
              {description}
            </motion.p>
            <motion.p
              className='home-hero-powered-by'
              variants={descriptionAnimation}
            >
              {supportingCopy}
            </motion.p>
            <div className='home-hero-button-container'>
              <BookADemoButton />
              <Link className='book-demo-button hero-learn-more' to={learnMoreHref}>
                {learnMoreLabel}
              </Link>
            </div>
            {credibilityLine && (
              <motion.p
                className='home-hero-credibility-line'
                variants={descriptionAnimation}
              >
                {credibilityLine}
              </motion.p>
            )}
          </div>
        </AnimatedContainer>
      </div>
      {children}
    </section>
  )
}

export default HomeHeroComponent
